// extracted by mini-css-extract-plugin
export default {"space90":"index_space90_496oC","footcolumn":"index_footcolumn_rfMrt"};